const transformStringToBoolean = (value, defaultValue) => {
  const result = Array.isArray(value) ? value[0] : value;
  // The boolean value is retrieved from table component,
  // while the string is extracted from the query parameters in the URL.
  switch (result) {
    case 'true':
    case true:
      return true;
    case 'false':
    case false:
      return false;
    default:
      return defaultValue;
  }
};

export default [
  {
    path: '/login',
    name: 'Login',
    view: 'Login',
  },
  {
    path: '/mfa/validate',
    view: 'MultiFactorAuthenticationCodeForm',
    name: 'Validate User MFA',
  },
  {
    path: '/nodes',
    view: 'Nodes',
    name: 'Nodes',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.nodes.view',
    },
  },
  {
    path: '/labels',
    view: 'Labels',
    name: 'Labels',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.labels.view',
    },
  },
  {
    path: '/labels/merge',
    view: 'MergeLabels',
    name: 'Merge Labels',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.labels.merge',
    },
  },
  {
    path: '/labels/:id',
    view: 'AddEditLabel',
    name: 'Add Edit Label',
    meta: {
      requiresAuth: true,
      title: (route) =>
        route.params.id === 'new' ? 'toolbar.pageTitles.labels.add' : 'toolbar.pageTitles.labels.edit',
    },
  },
  {
    path: '/',
    name: 'Home',
    redirect: {
      name: 'Nodes',
      path: '/nodes',
    },
    view: 'Nodes',
    meta: {
      requiresAuth: true,
      title: 'toolbar.pageTitles.nodes.view',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Home',
    redirect: {
      name: 'Nodes',
      path: '/nodes',
    },
    view: 'Nodes',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.nodes.view',
    },
  },
  {
    path: '/notifications',
    view: 'Notifications',
    name: 'Notifications',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.notifications.view',
    },
  },
  {
    path: '/notifications/:id',
    view: 'AddEditNotification',
    name: 'Add edit notification',
    meta: {
      requiresAuth: true,
      title: (route) =>
        route.params.id === 'new' ? 'toolbar.pageTitles.notifications.add' : 'toolbar.pageTitles.notifications.edit',
    },
  },
  {
    path: '/nodes/new',
    view: 'AddNode',
    name: 'Add node',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.nodes.add',
    },
  },
  {
    path: '/remotes',
    view: 'ActiveRemoteConnections',
    name: 'Active Remote Connections',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.remotes',
    },
  },
  {
    path: '/users',
    view: 'Users',
    name: 'Users',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.access.users.view',
    },
  },
  {
    path: '/users/:id',
    view: 'AddEditUser',
    name: 'Add Edit User',
    meta: {
      requiresAuth: true,
      title: (route) =>
        route.params.id === 'new' ? 'toolbar.pageTitles.access.users.add' : 'toolbar.pageTitles.access.users.edit',
    },
  },
  {
    path: '/user_settings',
    view: 'AddEditUser',
    name: 'User Settings',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.access.users.settings',
    },
  },
  {
    path: '/device/:currentGtwId/:id',
    view: 'DeployedWorkloadControl',
    name: 'Deployed workload control',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.nodes.workloadControl',
    },
    props: (route) => ({
      serialNumber: route.query.serialNumber,
      workloadId: route.query.workloadId,
      tab: Number(route.query.tab),
    }),
  },
  {
    path: '/roles',
    view: 'Roles',
    name: 'Roles',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.access.roles.view',
    },
  },
  {
    path: '/roles/:id',
    view: 'RoleDetails',
    name: 'Role Details',
    meta: {
      requiresAuth: true,
      title: (route) =>
        route.params.id === 'new' ? 'toolbar.pageTitles.access.roles.add' : 'toolbar.pageTitles.access.roles.edit',
    },
  },
  {
    path: '/ldap',
    view: 'Ldap',
    name: 'Ldap',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.access.ldap',
    },
  },
  {
    path: '/node/update/list',
    view: 'NodeUpdateList',
    name: 'Node Update List',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.nodes.update.view',
    },
  },
  {
    path: '/node/update/log',
    view: 'NodeUpdateLog',
    name: 'Node Update Log',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.nodes.update.log',
    },
  },
  {
    path: '/node/update/log/:id',
    view: 'NodeUpdateDetails',
    name: 'Node Update Details',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.nodes.update.details',
    },
  },
  {
    path: '/workloads',
    view: 'Workloads',
    name: 'Workloads',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.workloads.view',
    },
  },
  {
    path: '/workloads/:id/:type',
    view: 'AddEditWorkload',
    name: 'Add edit workload',
    meta: {
      requiresAuth: true,
      title: (route) =>
        route.params.id === 'new' ? 'toolbar.pageTitles.workloads.add' : 'toolbar.pageTitles.workloads.edit',
    },
    props: (route) => ({
      internalDockerRegistry: [transformStringToBoolean(route.query.internalDockerRegistry, true)],
    }),
  },
  {
    path: '/workloads/:workloadId/versions/:versionId/:type',
    view: 'AddEditWorkloadVersion',
    name: 'Add edit workload version',
    meta: {
      requiresAuth: true,
      title: (route) => {
        const titles = {
          new: 'toolbar.pageTitles.workloads.versions.add',
          clone: 'toolbar.pageTitles.workloads.versions.clone',
        };
        return titles[route.params.versionId] || 'toolbar.pageTitles.workloads.versions.edit';
      },
    },
    props: (route) => ({
      internalDockerRegistry: [transformStringToBoolean(route.query.internalDockerRegistry, true)],
    }),
  },
  {
    path: '/reset-credentials',
    view: 'ForgotPassword',
    name: 'Forgot Password',
  },
  {
    path: '/password/reset/:resetToken',
    view: 'ResetPassword',
    name: 'Reset Password',
  },
  {
    path: '/mfa/reset/:generationToken',
    view: 'MultiFactorAuthenticationQRCode',
    name: 'Reset User MFA',
  },
  {
    path: '/activate/:activationToken',
    view: 'ActivateProfile',
    name: 'Activate Profile',
  },
  {
    path: '/mfa/activate/:generationToken',
    view: 'MultiFactorAuthenticationQRCode',
    name: 'Activate User MFA',
    props: true,
  },
  {
    path: '/deploy/workload',
    view: 'DeployForm',
    name: 'Deploy Form',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.deploy.deployments',
    },
  },
  {
    path: '/deploy/workload/:type/:usingRegistry/:workloadId/:versionId/:origin',
    view: 'DeployForm',
    name: 'Deploy Form Step Two',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.deploy.deployments',
    },
  },
  {
    path: '/deploy/log',
    view: 'DeployLogList',
    name: 'Deploy Log List',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.deploy.log',
    },
  },
  {
    path: '/deploy/details/:id',
    view: 'DeployDetails',
    name: 'Deploy Details',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.deploy.details',
    },
  },
  {
    path: '/gClient/:authToken/:identifier',
    view: 'GuacamoleClient',
    name: 'Guacamole Client',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/registry',
    view: 'ManagementSystemRegistry',
    name: 'Management System Registry',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.registry',
    },
  },
  {
    path: '/available-updates',
    view: 'AvailableUpdates',
    name: 'Available Updates',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.system.update',
    },
  },
  {
    path: '/usage-reports',
    view: 'UsageReports',
    name: 'Usage Reports',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.system.usageReports',
    },
  },
  {
    path: '/logs',
    view: 'SystemLogs',
    name: 'System Logs',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.system.logs',
    },
  },
  {
    path: '/about',
    view: 'About',
    name: 'About',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.system.about',
    },
  },
  {
    path: '/downloads/remote-connection-manager',
    view: 'DownloadNerveConnectionManager',
    name: 'Download Nerve Connection Manager',
    meta: {
      requiresAuth: true,
      title: () => 'toolbar.pageTitles.downloads',
    },
  },
];
